// extracted by mini-css-extract-plugin
export default {"SearchBar__input":"SearchBar_SearchBar__input__djR2n"};